module.exports = __webpack_public_path__ + "static/media/about.8ffd96e0.svg";